var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData)?_c('bar-chart',{attrs:{"chart-id":"combo","chart-data":_vm.chartData,"options":_vm.chartOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }